// Yazili PhoneCustomer / PhoneOrder uclarinin arayuz tarafindaki cagrilari.
import { configWithUserToken } from "../../services/config";
import {
  ICreatePhoneCustomer, ICreatePhoneOrder, IPhoneCustomer, IPhoneCustomerSearchResult,
  IPhoneOrder, IPhoneOrderLedgerPage, IUpdatePhoneCustomer,
} from "../models/IPhoneOrder";

/* ---------------------------------------------------------- müşteri dizini */

/**
 * Tek arama kutusu: sorgu rakam ya da + ile basliyorsa numara, degilse ad aramasi.
 * 0533 = 533 = +90533 = 90533 ayni kumeyi bulur (bastan eslesme).
 */
export const searchPhoneCustomers = (restaurantId: string, query: string) => {
  const p = new URLSearchParams({ restourantId: restaurantId, query });
  return configWithUserToken.get<IPhoneCustomerSearchResult>(`PhoneCustomer/search?${p.toString()}`);
};

/** Yeni kayit. Ayni numara ikinci kez kaydedilemez (PhoneCustomerAlreadyExists, 409). */
export const createPhoneCustomer = (data: ICreatePhoneCustomer) =>
  configWithUserToken.post<IPhoneCustomer>("PhoneCustomer", data);

/** Degistirme: her alan gonderilir ve yazilir. Govdede restourantId yok. */
export const updatePhoneCustomer = (data: IUpdatePhoneCustomer) =>
  configWithUserToken.put<IPhoneCustomer>("PhoneCustomer", data);

/* ------------------------------------------------------------ sipariş alma */

/**
 * Tek islemde yazilir; ortada hata olursa hicbir sey kalmaz.
 * Idempotency-Key gerekmiyor, gonderilse yok sayilir: cift gonderim IKI SIPARIS demektir,
 * bu yuzden cagiran butonu yanit donene kadar kilitlemeli.
 */
export const createPhoneOrder = (data: ICreatePhoneOrder) =>
  configWithUserToken.post<IPhoneOrder>("PhoneOrder", data);

/**
 * Odeme yontemini belirler / duzeltir. Her durumda calisir (teslim edilmis siparis dahil),
 * iptalli siparis haric. Geri alinamaz: Belirlenmedi'ye donulemez.
 */
export const updatePhoneOrderPaymentMethod = (orderId: string, paymentMethodId: string) =>
  configWithUserToken.put<IPhoneOrder>("PhoneOrder/payment-method", { orderId, paymentMethodId });

export interface IPhoneOrderLedgerParams {
  restaurantId: string;
  /** from ve to birlikte gonderilir; yalniz biri 400 alir. Gonderilmezse sunucu bugunu uygular. */
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

export const getPhoneOrderLedger = (params: IPhoneOrderLedgerParams) => {
  const p = new URLSearchParams();
  p.append("restourantId", params.restaurantId);
  if (params.from && params.to) {
    p.append("from", params.from);
    p.append("to", params.to);
  }
  p.append("page", String(params.page ?? 1));
  p.append("pageSize", String(params.pageSize ?? 20));
  return configWithUserToken.get<IPhoneOrderLedgerPage>(`PhoneOrder/ledger?${p.toString()}`);
};

/* -------------------------------------------------------------- hata okuma */

/** Hata govdesi dizidir: [{ code, description }]. Dal durum koduna degil koda yazilir. */
export function phoneErrorCode(err: any): string | undefined {
  const data = err?.response?.data;
  return Array.isArray(data) ? data[0]?.code : undefined;
}

export function phoneErrorDescription(err: any): string | undefined {
  const data = err?.response?.data;
  return Array.isArray(data) ? data[0]?.description : undefined;
}

/**
 * Ayni kurallar istek tipinin dogrulayicisinda da ilan edildigi icin sinir disi degerler
 * servise hic ulasmaz: yanit ValidationProblemDetails olur ve [0].code bulunmaz.
 * Bu yuzden ekran iki govdeye birden hazir olmali.
 */
export function phoneValidationMessage(err: any): string | undefined {
  const errors = err?.response?.data?.errors;
  if (!errors || typeof errors !== "object") return undefined;
  const first = Object.values(errors as Record<string, string[] | string>)[0];
  const text = Array.isArray(first) ? first[0] : first;
  return typeof text === "string" && text.trim() ? text : undefined;
}

/** Kod -> Turkce metin esleme, ardindan sunucunun aciklamasi, ardindan yedek metin. */
export function phoneErrorMessage(err: any, map: Record<string, string>, fallback: string): string {
  const code = phoneErrorCode(err);
  if (code && map[code]) return map[code];
  return phoneErrorDescription(err) ?? phoneValidationMessage(err) ?? fallback;
}

/** PhoneCustomerAlreadyExists aciklamasi mevcut kaydin id'sini sonunda tasir. */
export function existingCustomerIdFromError(err: any): string | undefined {
  const desc = phoneErrorDescription(err);
  if (!desc) return undefined;
  const match = desc.match(/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/);
  return match?.[1];
}
